import React from 'react'
import { SanityKpiBlock } from '../../../../../types/generated/graphql-types'
import { sanityKpiBlockToKpiBlockProps } from '../../../../mapping/KpiBlockMapping'
import { BlockWithId } from '../../../../utilities/blockId'
import { KpiBlock } from '../../../blocks/KpiBlock'
import { MarketSection } from '../../../MarketSection'

export const KpiBlockSerializer = ({ id, ...props }: SanityKpiBlock & BlockWithId) => (
  <MarketSection id={id}>
    <KpiBlock {...sanityKpiBlockToKpiBlockProps(props)} />
  </MarketSection>
)
